export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.356843497cba080ca56b308809670ed8.css";